import { Injectable } from '@angular/core';
import {
  CheckoutCompletedItem,
  CheckoutPaymentDetails,
  CompletedQuoteDetails,
} from '@checkout/util-models';
import {
  CustomerDetails,
  CustomerMarketingPreferenceDetails,
  DocumentSendMethod,
} from '@domgen/dgx-fe-common';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as CheckoutActions from './checkout.actions';
import * as CheckoutSelectors from './checkout.selectors';

@Injectable({
  providedIn: 'root',
})
export class CheckoutFacade {
  completedItems$: Observable<CheckoutCompletedItem[]> = this.store.select(
    CheckoutSelectors.selectCompletedItems
  );

  completedQuotes$: Observable<CompletedQuoteDetails[]> = this.store.select(
    CheckoutSelectors.selectCompletedQuotes
  );

  customerDetails$: Observable<CustomerDetails | undefined> = this.store.select(
    CheckoutSelectors.selectCustomerDetails
  );

  firstCompletedQuote$: Observable<CompletedQuoteDetails | undefined> =
    this.store.select(CheckoutSelectors.selectFirstCompletedQuote);

  hasCompletedAllSelectedQuotes$: Observable<boolean> = this.store.select(
    CheckoutSelectors.selectHasCompletedAllSelectedQuotes
  );

  hasCompletedItems$: Observable<boolean> = this.store.select(
    CheckoutSelectors.selectHasCompletedItems
  );

  hasCompletedQuotes$: Observable<boolean> = this.store.select(
    CheckoutSelectors.selectHasCompletedQuotes
  );

  purchasing$: Observable<boolean> = this.store.select(
    CheckoutSelectors.selectPurchasing
  );

  hasMonthsFreePromotionalOffer$: Observable<boolean> = this.store.select(
    CheckoutSelectors.selectHasMonthsFreePromotionalOffer
  );

  constructor(private readonly store: Store) {}

  checkoutRequest(paymentDetails: CheckoutPaymentDetails): void {
    this.store.dispatch(
      CheckoutActions.checkoutRequest({
        paymentDetails,
      })
    );
  }

  removeCompletedItems(): void {
    this.store.dispatch(CheckoutActions.removeCompletedItems());
  }

  resetMarketingPreferences(): void {
    this.store.dispatch(CheckoutActions.resetMarketingPreferences());
  }

  upsertCustomerDetails(customerDetails: CustomerDetails): void {
    this.store.dispatch(
      CheckoutActions.upsertCustomerDetails({
        customerDetails,
      })
    );
  }

  upsertCustomerMarketingPreferenceDetails(
    marketingPreferences: CustomerMarketingPreferenceDetails
  ): void {
    this.store.dispatch(
      CheckoutActions.upsertCustomerMarketingPreferenceDetails({
        marketingPreferences,
      })
    );
  }

  updateDocumentSendMethod(documentSendMethod: DocumentSendMethod): void {
    this.store.dispatch(
      CheckoutActions.updateDocumentSendMethod({
        documentSendMethod,
      })
    );
  }
}
